/**
 * @fileoverview Component Header
 *
 * Purpose: Display component name with file source information
 * Used by: Component library sections
 */

import { FileCode } from "lucide-react";

interface ComponentHeaderProps {
  title: string;
  description: string;
  filePath: string;
}

export function ComponentHeader({
  title,
  description,
  filePath,
}: ComponentHeaderProps) {
  return (
    <div className="space-y-3">
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 space-y-2">
          <h2 className="text-2xl font-bold tracking-tight">{title}</h2>
          <p className="text-muted-foreground">{description}</p>
        </div>
      </div>
      <div className="flex items-center gap-2 text-sm">
        <FileCode className="h-4 w-4 text-muted-foreground" />
        <code className="rounded bg-muted px-2 py-1 font-mono text-xs text-muted-foreground">
          {filePath}
        </code>
      </div>
    </div>
  );
}
